// extracted by mini-css-extract-plugin
module.exports = {"faqRegion":"FAQBlock_faqRegion__3So5j","faqRegionTitle":"FAQBlock_faqRegionTitle__2jr6X"};